var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333374,
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_radial_13657_36357)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13657_36357)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13657_36357",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 33,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3334,
    y: 12,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13657_36357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 28.196C21.0778 26.7294 21.7723 25.3182 22.5834 23.9627C23.3945 22.6071 24.3112 21.3294 25.3334 20.1294L23.6001 19.7627C23.1556 19.6738 22.7223 19.696 22.3001 19.8294C21.8778 19.9627 21.5112 20.1849 21.2001 20.496L17.0001 24.696C16.6667 25.0294 16.539 25.4294 16.6167 25.896C16.6945 26.3627 16.9556 26.6849 17.4001 26.8627L20.5001 28.196ZM40.1001 15.196C37.7445 15.0849 35.5056 15.5405 33.3834 16.5627C31.2612 17.5849 29.3667 18.9294 27.7001 20.596C26.6334 21.6627 25.6945 22.8182 24.8834 24.0627C24.0723 25.3071 23.3667 26.6182 22.7667 27.996C22.6556 28.2849 22.6001 28.5794 22.6001 28.8794C22.6001 29.1794 22.7112 29.4405 22.9334 29.6627L27.1001 33.8294C27.3223 34.0516 27.5834 34.1627 27.8834 34.1627C28.1834 34.1627 28.4778 34.1071 28.7667 33.996C30.1445 33.396 31.4556 32.6905 32.7001 31.8794C33.9445 31.0682 35.1001 30.1294 36.1667 29.0627C37.8334 27.396 39.1778 25.5016 40.2001 23.3794C41.2223 21.2571 41.6778 19.0182 41.5667 16.6627C41.5667 16.4849 41.5223 16.3071 41.4334 16.1294C41.3445 15.9516 41.2334 15.796 41.1001 15.6627C40.9667 15.5294 40.8112 15.4182 40.6334 15.3294C40.4556 15.2405 40.2778 15.196 40.1001 15.196ZM31.6334 25.1294C31.1223 24.6182 30.8667 23.9905 30.8667 23.246C30.8667 22.5016 31.1223 21.8738 31.6334 21.3627C32.1445 20.8516 32.7723 20.596 33.5167 20.596C34.2612 20.596 34.889 20.8516 35.4001 21.3627C35.9112 21.8738 36.1667 22.5016 36.1667 23.246C36.1667 23.9905 35.9112 24.6182 35.4001 25.1294C34.889 25.6405 34.2612 25.896 33.5167 25.896C32.7723 25.896 32.1445 25.6405 31.6334 25.1294ZM28.5667 36.2627L29.9001 39.3627C30.0778 39.8071 30.4001 40.0738 30.8667 40.1627C31.3334 40.2516 31.7334 40.1294 32.0667 39.796L36.2667 35.596C36.5778 35.2849 36.8001 34.9127 36.9334 34.4794C37.0667 34.046 37.089 33.6071 37.0001 33.1627L36.6667 31.4294C35.4445 32.4516 34.1612 33.3682 32.8167 34.1794C31.4723 34.9905 30.0556 35.6849 28.5667 36.2627ZM17.7334 33.396C18.5112 32.6182 19.4556 32.2238 20.5667 32.2127C21.6778 32.2016 22.6223 32.5849 23.4001 33.3627C24.1778 34.1405 24.5667 35.0849 24.5667 36.196C24.5667 37.3071 24.1778 38.2516 23.4001 39.0294C22.3334 40.096 21.0723 40.7294 19.6167 40.9294C18.1612 41.1294 16.7001 41.3294 15.2334 41.5294C15.4334 40.0627 15.639 38.6016 15.8501 37.146C16.0612 35.6905 16.689 34.4405 17.7334 33.396Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13657_36357",
    x: 9.2334,
    y: 11.1797,
    width: 38.3497,
    height: 38.3516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.539187 0 0 0 0 0.225757 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13657_36357"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13657_36357",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_13657_36357",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5 16) rotate(48.9452) scale(61.6644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.a53161405135e8497ffe76c70cf6a4ab.svg";
export { ForwardRef as ReactComponent };